var _path, _g, _path2, _path3, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _g3, _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateRequest({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 137,
    viewBox: "0 0 162 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.0552 119C111.297 119 135.814 94.3685 135.814 63.9835C135.814 33.5986 111.297 8.9668 81.0552 8.9668C50.813 8.9668 26.2969 33.5986 26.2969 63.9835C26.2969 94.3685 50.813 119 81.0552 119Z",
    fill: "#EFF3FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4808_253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.67 27.6744V100.403C139.67 102.285 138.237 103.724 136.364 103.724H25.3053C23.4323 103.724 22 102.285 22 100.403V27.6744C22 25.7925 23.4323 24.3535 25.3053 24.3535H136.364C138.237 24.3535 139.67 25.7925 139.67 27.6744Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M139.78 27.6744V31.5H22.1102V27.6744C22.1102 25.7926 23.5425 24.3535 25.4156 24.3535H136.475C138.238 24.3535 139.78 25.7926 139.78 27.6744Z",
    fill: "url(#paint0_linear_4808_253)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 29C26.5523 29 27 28.5523 27 28C27 27.4477 26.5523 27 26 27C25.4477 27 25 27.4477 25 28C25 28.5523 25.4477 29 26 29Z",
    fill: "#FDFDFD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M29 29C29.5523 29 30 28.5523 30 28C30 27.4477 29.5523 27 29 27C28.4477 27 28 27.4477 28 28C28 28.5523 28.4477 29 29 29Z",
    fill: "#FDFDFD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M32 29C32.5523 29 33 28.5523 33 28C33 27.4477 32.5523 27 32 27C31.4477 27 31 27.4477 31 28C31 28.5523 31.4477 29 32 29Z",
    fill: "#FDFDFD"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4808_253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.311 99.074H57.9179C56.8161 99.074 55.9347 98.1884 55.9347 97.0814V39.6293C55.9347 38.5223 56.8161 37.6367 57.9179 37.6367H103.311C104.413 37.6367 105.294 38.5223 105.294 39.6293V97.0814C105.294 98.1884 104.413 99.074 103.311 99.074Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0142 83.4652H62.6555C61.7741 83.4652 61.113 82.801 61.113 81.9154V58.6689C61.113 57.7833 61.7741 57.1191 62.6555 57.1191H98.904C99.7854 57.1191 100.446 57.7833 100.446 58.6689V81.9154C100.557 82.801 99.8956 83.4652 99.0142 83.4652Z",
    fill: "#E6EDF5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3773 79.9243H65.5201L74.0038 70.4043L82.3773 79.9243Z",
    fill: "#CED7E2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1495 79.9238H72.0206L84.1402 66.1973L96.1495 79.9238Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9105 66.8619C73.6751 66.8619 75.1056 65.4246 75.1056 63.6517C75.1056 61.8787 73.6751 60.4414 71.9105 60.4414C70.1458 60.4414 68.7153 61.8787 68.7153 63.6517C68.7153 65.4246 70.1458 66.8619 71.9105 66.8619Z",
    fill: "#CED7E2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M133.5 98.188H111.134C110.583 98.188 110.142 97.7452 110.142 97.1917V82.801C110.142 82.2475 110.583 81.8047 111.134 81.8047H133.5C134.051 81.8047 134.491 82.2475 134.491 82.801V97.1917C134.491 97.7452 134.051 98.188 133.5 98.188Z",
    fill: "#E6EDF5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M123.143 95.9743H112.896L118.075 90.1074L123.143 95.9743Z",
    fill: "#CED7E2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M131.737 95.9755H116.863L124.245 87.5625L131.737 95.9755Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M116.753 88.0046C117.848 88.0046 118.736 87.1125 118.736 86.012C118.736 84.9116 117.848 84.0195 116.753 84.0195C115.657 84.0195 114.77 84.9116 114.77 86.012C114.77 87.1125 115.657 88.0046 116.753 88.0046Z",
    fill: "#CED7E2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M133.5 76.602H111.134C110.583 76.602 110.142 76.1592 110.142 75.6057V61.215C110.142 60.6615 110.583 60.2188 111.134 60.2188H133.5C134.051 60.2188 134.491 60.6615 134.491 61.215V75.6057C134.491 76.1592 134.051 76.602 133.5 76.602Z",
    fill: "#E6EDF5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M123.143 74.3885H112.896L118.075 68.5215L123.143 74.3885Z",
    fill: "#CED7E2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M131.737 74.3889H116.863L124.245 65.8652L131.737 74.3889Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M116.753 66.3075C117.848 66.3075 118.736 65.4154 118.736 64.3149C118.736 63.2144 117.848 62.3223 116.753 62.3223C115.657 62.3223 114.77 63.2144 114.77 64.3149C114.77 65.4154 115.657 66.3075 116.753 66.3075Z",
    fill: "#CED7E2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M133.5 54.9066H111.134C110.583 54.9066 110.142 54.4638 110.142 53.9103V39.5196C110.142 38.9662 110.583 38.5234 111.134 38.5234H133.5C134.051 38.5234 134.491 38.9662 134.491 39.5196V53.9103C134.491 54.4638 134.051 54.9066 133.5 54.9066Z",
    fill: "#E6EDF5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M123.143 52.6912H112.896L118.075 46.8242L123.143 52.6912Z",
    fill: "#CED7E2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M131.737 52.6923H116.863L124.245 44.2793L131.737 52.6923Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M116.753 44.7214C117.848 44.7214 118.736 43.8293 118.736 42.7288C118.736 41.6284 117.848 40.7363 116.753 40.7363C115.657 40.7363 114.77 41.6284 114.77 42.7288C114.77 43.8293 115.657 44.7214 116.753 44.7214Z",
    fill: "#CED7E2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M100.116 43.7249H61.664C61.2233 43.7249 61.0029 43.3928 61.0029 43.0607C61.0029 42.6179 61.3335 42.3965 61.664 42.3965H100.006C100.447 42.3965 100.667 42.7286 100.667 43.0607C100.777 43.3928 100.447 43.7249 100.116 43.7249Z",
    fill: "#E6EDF5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M100.116 47.7112H61.664C61.2233 47.7112 61.0029 47.3791 61.0029 47.047C61.0029 46.6042 61.3335 46.3828 61.664 46.3828H100.006C100.447 46.3828 100.667 46.7149 100.667 47.047C100.777 47.3791 100.447 47.7112 100.116 47.7112Z",
    fill: "#E6EDF5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3186 89.4436H61.664C61.2233 89.4436 61.0029 89.1115 61.0029 88.7794C61.0029 88.3366 61.3335 88.1152 61.664 88.1152H89.3186C89.7593 88.1152 89.9797 88.4473 89.9797 88.7794C89.9797 89.1115 89.6491 89.4436 89.3186 89.4436Z",
    fill: "#E6EDF5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0553 52.0276H61.664C61.2233 52.0276 61.0029 51.6955 61.0029 51.3634C61.0029 50.9206 61.3335 50.6992 61.664 50.6992H80.9451C81.3858 50.6992 81.6062 51.0313 81.6062 51.3634C81.7163 51.6955 81.3858 52.0276 81.0553 52.0276Z",
    fill: "url(#paint1_linear_4808_253)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M100.116 93.5393H61.664C61.2233 93.5393 61.0029 93.2072 61.0029 92.8751C61.0029 92.4323 61.3335 92.2109 61.664 92.2109H100.006C100.447 92.2109 100.667 92.543 100.667 92.8751C100.777 93.2072 100.447 93.5393 100.116 93.5393Z",
    fill: "#E6EDF5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M100.116 89.4436H92.624C92.1832 89.4436 91.9629 89.1115 91.9629 88.7794C91.9629 88.3366 92.2934 88.1152 92.624 88.1152H100.116C100.557 88.1152 100.777 88.4473 100.777 88.7794C100.777 89.1115 100.447 89.4436 100.116 89.4436Z",
    fill: "url(#paint2_linear_4808_253)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6546 98.7419H28.6106C27.2885 98.7419 26.2969 97.7457 26.2969 96.4173V39.6294C26.2969 38.301 27.2885 37.3047 28.6106 37.3047H49.5444C50.8665 37.3047 51.8581 38.301 51.8581 39.6294V96.4173C51.9683 97.7457 50.8665 98.7419 49.6546 98.7419Z",
    fill: "#1C3754"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1877 45.053C40.5872 45.053 41.7217 43.9131 41.7217 42.507C41.7217 41.1008 40.5872 39.9609 39.1877 39.9609C37.7881 39.9609 36.6536 41.1008 36.6536 42.507C36.6536 43.9131 37.7881 45.053 39.1877 45.053Z",
    fill: "#2D5887"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2308 48.1532H31.1448C30.9245 48.1532 30.7041 47.9318 30.7041 47.7104C30.7041 47.489 30.9245 47.2676 31.1448 47.2676H47.2308C47.4511 47.2676 47.6715 47.489 47.6715 47.7104C47.6715 47.9318 47.4511 48.1532 47.2308 48.1532Z",
    fill: "#2D5887"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2308 51.5848H31.1448C30.9245 51.5848 30.7041 51.3634 30.7041 51.142C30.7041 50.9206 30.9245 50.6992 31.1448 50.6992H47.2308C47.4511 50.6992 47.6715 50.9206 47.6715 51.142C47.6715 51.3634 47.4511 51.5848 47.2308 51.5848Z",
    fill: "#2D5887"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2308 57.4514H31.1448C30.9245 57.4514 30.7041 57.23 30.7041 57.0086C30.7041 56.6765 30.8143 56.4551 31.1448 56.4551H47.2308C47.4511 56.4551 47.6715 56.6765 47.6715 56.8979C47.6715 57.23 47.4511 57.4514 47.2308 57.4514Z",
    fill: "#2D5887"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9842 60.883H30.9244C30.8142 60.883 30.5939 60.7723 30.5939 60.5509V60.2188C30.5939 60.1081 30.704 59.8867 30.9244 59.8867H36.874C36.9842 59.8867 37.2045 59.9974 37.2045 60.2188V60.5509C37.2045 60.7723 37.0944 60.883 36.9842 60.883Z",
    fill: "#2D5887"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2308 66.9715H31.1448C30.9245 66.9715 30.7041 66.7501 30.7041 66.5287C30.7041 66.3073 30.9245 66.0859 31.1448 66.0859H47.2308C47.4511 66.0859 47.6715 66.3073 47.6715 66.5287C47.6715 66.7501 47.4511 66.9715 47.2308 66.9715Z",
    fill: "#2D5887"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9842 70.4044H30.9244C30.8142 70.4044 30.5939 70.2938 30.5939 70.0724V69.7403C30.5939 69.6296 30.704 69.4082 30.9244 69.4082H36.874C36.9842 69.4082 37.2045 69.5189 37.2045 69.7403V70.0724C37.2045 70.2938 37.0944 70.4044 36.9842 70.4044Z",
    fill: "#2D5887"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2308 76.493H31.1448C30.9245 76.493 30.7041 76.2716 30.7041 76.0502C30.7041 75.8288 30.9245 75.6074 31.1448 75.6074H47.2308C47.4511 75.6074 47.6715 75.8288 47.6715 76.0502C47.6715 76.3823 47.4511 76.493 47.2308 76.493Z",
    fill: "#2D5887"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9842 79.9239H30.9244C30.8142 79.9239 30.5939 79.8132 30.5939 79.5918V79.2597C30.5939 79.1491 30.704 78.9277 30.9244 78.9277H36.874C36.9842 78.9277 37.2045 79.0384 37.2045 79.2597V79.7025C37.2045 79.8132 37.0944 79.9239 36.9842 79.9239Z",
    fill: "url(#paint3_linear_4808_253)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M124.906 21.2548C127.218 21.2548 129.093 19.3715 129.093 17.0483C129.093 14.7251 127.218 12.8418 124.906 12.8418C122.594 12.8418 120.719 14.7251 120.719 17.0483C120.719 19.3715 122.594 21.2548 124.906 21.2548Z",
    fill: "#EAEEF9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2222 8.96652C49.7435 8.96652 50.9767 7.7275 50.9767 6.19908C50.9767 4.67067 49.7435 3.43164 48.2222 3.43164C46.701 3.43164 45.4678 4.67067 45.4678 6.19908C45.4678 7.7275 46.701 8.96652 48.2222 8.96652Z",
    fill: "#EAEEF9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6621 16.0508C36.6965 16.0508 37.5351 15.2083 37.5351 14.1689C37.5351 13.1296 36.6965 12.2871 35.6621 12.2871C34.6276 12.2871 33.7891 13.1296 33.7891 14.1689C33.7891 15.2083 34.6276 16.0508 35.6621 16.0508Z",
    fill: "#EAEEF9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M120.058 3.54233C121.032 3.54233 121.821 2.74935 121.821 1.77116C121.821 0.792977 121.032 0 120.058 0C119.085 0 118.295 0.792977 118.295 1.77116C118.295 2.74935 119.085 3.54233 120.058 3.54233Z",
    fill: "#EAEEF9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0691 118.336C40.921 118.336 41.6116 117.642 41.6116 116.786C41.6116 115.93 40.921 115.236 40.0691 115.236C39.2172 115.236 38.5266 115.93 38.5266 116.786C38.5266 117.642 39.2172 118.336 40.0691 118.336Z",
    fill: "url(#paint4_linear_4808_253)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M100.777 3.9843C101.629 3.9843 102.32 3.29045 102.32 2.43454C102.32 1.57862 101.629 0.884766 100.777 0.884766C99.9252 0.884766 99.2346 1.57862 99.2346 2.43454C99.2346 3.29045 99.9252 3.9843 100.777 3.9843Z",
    fill: "url(#paint5_linear_4808_253)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4808_253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.882 83.6872C140.221 81.2518 138.678 79.1486 136.475 77.8202C134.051 76.3811 131.517 76.1597 128.762 75.9384C123.914 75.3849 118.956 75.2742 113.998 75.4956C109.591 75.6063 104.523 75.3849 100.446 77.2667C94.6071 79.8128 93.8358 85.4584 93.6155 91.5467C93.3951 96.0853 93.3951 101.51 94.6071 105.938C95.5987 109.48 98.3531 112.247 101.989 113.022C106.616 114.129 116.532 114.351 121.38 114.24C121.821 114.24 122.262 114.24 122.702 114.24C126.559 114.129 130.635 114.129 134.161 112.801C137.136 111.805 138.898 110.033 140 107.819C141.322 105.163 141.653 101.842 141.763 98.1886C142.204 93.4286 142.094 88.0044 140.882 83.6872Z",
    fill: "url(#paint6_linear_4808_253)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 87,
    width: 2,
    height: 15,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 110.5,
    y: 95.5,
    width: 2,
    height: 15,
    transform: "rotate(-90 110.5 95.5)",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4808_253",
    x: 0,
    y: 13.3535,
    width: 161.67,
    height: 123.371,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4808_253"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4808_253",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4808_253",
    x: 33.9347,
    y: 26.6367,
    width: 93.3593,
    height: 105.438,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4808_253"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4808_253",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4808_253",
    x: 85.5034,
    y: 72.3887,
    width: 64.4967,
    height: 54.877,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101505 0 0 0 0 0.187232 0 0 0 0 0.408218 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4808_253"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4808_253",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4808_253",
    x1: 22.0832,
    y1: 29.3318,
    x2: 139.748,
    y2: 29.3318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2539D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4808_253",
    x1: 60.9689,
    y1: 51.2785,
    x2: 81.7282,
    y2: 51.2785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F53689"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4808_253",
    x1: 91.8635,
    y1: 88.7689,
    x2: 100.779,
    y2: 88.7689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F53689"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4808_253",
    x1: 30.6554,
    y1: 79.4865,
    x2: 37.2369,
    y2: 79.4865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F53689"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4808_253",
    x1: 38.5339,
    y1: 116.784,
    x2: 41.5099,
    y2: 116.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F53689"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4808_253",
    x1: 99.3007,
    y1: 2.48966,
    x2: 102.277,
    y2: 2.48966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A78FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4808_253",
    x1: 93.5915,
    y1: 94.7719,
    x2: 142.068,
    y2: 94.7719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99B3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2361FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateRequest);
export default __webpack_public_path__ + "static/media/createRequest.3065908f2e80399022f17530fc732ec4.svg";
export { ForwardRef as ReactComponent };